import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import MagneticButton from "./MagneticButton";

/**
 * TakeoffCTA — final cinematic "Cleared for takeoff" block with parallax airport
 * runway image, heavy dark overlay, large editorial italic headline + magnetic CTA.
 */
const TakeoffCTA = () => {
  return (
    <section
      className="relative overflow-hidden takeoff-bg"
      data-testid="takeoff-cta-section"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#10141d] via-transparent to-[#10141d]" />
      <div className="hero-runway" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 py-32 md:py-44 text-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-10 h-px bg-gold/70" />
            <span className="overline">Cleared for takeoff</span>
            <span className="w-10 h-px bg-gold/70" />
          </div>

          <h2 className="text-5xl sm:text-6xl md:text-7xl tracking-tighter font-light text-white leading-[1] mb-4">
            Klaar voor de
          </h2>
          <h2 className="font-display-italic text-6xl sm:text-7xl md:text-8xl text-gold leading-[1] mb-10">
            volgende stap?
          </h2>

          <p className="text-silver text-base md:text-lg max-w-2xl mx-auto mb-12 leading-relaxed">
            Plan je gratis proefles en ontdek waarom onze leerlingen
            lachend hun rijbewijs halen. Geen verplichtingen, alleen ervaring.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <MagneticButton>
              <Link
                to="/contact"
                className="btn-gold"
                data-testid="takeoff-cta-primary"
              >
                Plan gratis proefles{" "}
                <ArrowRight size={18} weight="bold" className="anim-arrow" />
              </Link>
            </MagneticButton>
            <MagneticButton>
              <Link
                to="/pakketten"
                className="btn-ghost"
                data-testid="takeoff-cta-secondary"
              >
                Bekijk pakketten
              </Link>
            </MagneticButton>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TakeoffCTA;
